import { uniqueId } from 'lodash';
import approveCenter from '../../images/links/gaia/icn-approval-center.png';
import eformApply from '../../images/links/gaia//icn-eform-apply.png';
import eformManage from '../../images//links/gaia/icn-eform-manage.png';
import eformRecord from '../../images//links/gaia/icn-eform-records.png';
import { url } from 'configs/';
const baseUrl = url.NEWTUBE_API_SERVER;
const basePTUrl = url.PT_API_SERVER;

const module = 'gaia';

export default [
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_eFormApproval',
    icon: approveCenter,
    // url: '/gaia-sso?targetPath=bpm/approve',
    url: `${basePTUrl}bpm/sso-redirect?targetPath=bpm/approve`,
    functionCode: 'FormSigning',
    messageApi: `${baseUrl}Gaia/FormApprove/UnreadCount`,
    sort: 18,
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_EformApply',
    icon: eformApply,
    // url: '/gaia-sso?targetPath=bpm%2Fapplyform%3FmoduleType%3Dapply',
    url: `${basePTUrl}bpm/sso-redirect?targetPath=bpm%2Fapplyform%3FmoduleType%3Dapply`,
    functionCode: 'FormApplication',
    messageApi: null,
    sort: 19,
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_EformManage',
    icon: eformRecord,
    // url: '/gaia-sso?targetPath=bpm/traceapply',
    url: `${basePTUrl}bpm/sso-redirect?targetPath=bpm/traceapply`,
    functionCode: 'MyForm',
    messageApi: null,
    sort: 20,
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_EformRecord',
    icon: eformManage,
    // url: '/gaia-sso?targetPath=bpm/FormApplication/InquiryCenter',
    url: `${basePTUrl}bpm/sso-redirect?targetPath=bpm/FormApplication/InquiryCenter`,
    functionCode: 'FormSearching',
    messageApi: null,
    sort: 21,
  },
];



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/Index/config/links/gaia.js
 **/